import React from "react";
import { Typography } from "antd";
import Apple from "../../assets/apple.png";
import Google from "../../assets/googleApp.png";

const { Title } = Typography;

const Footer = () => {
  return (
    <div className="mt-10 footer">
      <div className="flex justify-center">
        <img src={Apple} />
        <img src={Google} />
      </div>
      <div className="hidden lg:flex justify-between mt-2 text-center">
        <Title level={5}> About </Title>
        <Title level={5}>Cookie Policy </Title>
        <Title level={5}> F.A.Q </Title>
        <Title level={5}> Terms of Use </Title>
        <Title level={5}>Privacy Policy </Title>
      </div>
      <div className="text-center mt-2">
        <p className="inline font-bold"> All Rights reserved</p>
        <p className="inline font-bold"> SportsCliq 2022 </p>
      </div>
    </div>
  );
};

export default Footer;